import api from "./http";

const getStateAndCity = async () => {
  try {
    const response = await api.get(`/state-and-city`);
    return response.data;
  } catch (error) {
    console.error("Error fetching state and city data:", error);
    return error.message;
  }
};

const getAcademicYears = async () => {
  try {
    const response = await api.get(`/config/academic-years`);
    
    // Transform new API response to match old format for backward compatibility
    if (response.data.success && response.data.data) {
      const academicYears = response.data.data.map(year => ({
        id: year.academic_year,
        name: year.academic_year,
        start_date: year.start_date,
        end_date: year.end_date,
        academic_year: year.academic_year,
      }));
      
      return {
        status: "success",
        data: {
          academicYears: academicYears,
        },
      };
    }
    
    return response.data;
  } catch (error) {
    console.error("Error fetching academic years:", error);
    return error.message;
  }
};

const getCourseAndClass = async () => {
  try {
    const response = await api.get(`/course-and-class`);
    return response.data;
  } catch (error) {
    console.error("Error fetching courses and classes:", error);
    return error.message;
  }
};

export { getAcademicYears, getCourseAndClass, getStateAndCity };

// Re-export fees services
export * from "./fees";
